<template>
    <MenuBase :hidden="props.hidden" 
        :tooltipPosition="props.tooltipPosition" :theme="props.theme" 
        :tooltipText="active ? 'Hide song map' : 'Show song map'"
        :active="active"
        @menuClick="toggleSongMap()">
        <MapIcon class="size-6 " />
    </MenuBase>
</template>
<script setup>
import { ref, defineProps, defineEmits } from 'vue'
import MenuBase from '@/components/common/menus/MenuBase.vue';
import { MapIcon } from '@heroicons/vue/24/outline';
import { appEvents } from '@/store/app.events';

const emit = defineEmits(['toggleSongMap'])
const props = defineProps( {
    disabled: {
        type: Boolean,
        default: true
    },
    hidden: {
        type: Boolean,
        default: true
    },
    tooltipPosition: {
        type: String,
        default: 'top',
        validator: (value) => {
            return ['top', 'bottom', 'left', 'right'].includes(value);
        }
    },
    active: {
        type: Boolean,
        default: false
    }
})

const active = ref(props.active);

const toggleSongMap = () => {
    active.value = !active.value;
    emit('toggleSongMap', active.value);
    appEvents.emit('toggleSongMap', active.value);
}
appEvents.on('toggleSongMap', (value) => {
    active.value = value;
});
</script>